// extracted by mini-css-extract-plugin
export default {"markdown-img":"styles_markdown-img__uAEVh"};